export const RegistrationLinksConst = {
  SMSFINANCE: [
    'https://www.smsfinance.ru/documents/redaction/8/0',
    'https://www.smsfinance.ru/documents/redaction/17/0',
    'https://www.smsfinance.ru/documents/redaction/25/0',
    'https://www.smsfinance.ru/documents/redaction/70/0',
    'https://www.smsfinance.ru/documents/redaction/19/0',
    'https://www.smsfinance.ru/documents/redaction/33/0',
    'https://yoomoney.ru/pay/page?id=526623',
    'https://www.smsfinance.ru/documents/redaction/21/0',
    'https://www.smsfinance.ru/documents/redaction/83/0',
    'https://www.smsfinance.ru/documents/redaction/32/0'
  ],
  VIVUS: [
    'https://www.vivus.ru/documents/redaction/8/0',
    'https://www.vivus.ru/documents/redaction/17/0',
    'https://www.vivus.ru/documents/redaction/25/0',
    'https://www.vivus.ru/documents/redaction/70/0',
    'https://www.vivus.ru/documents/redaction/19/0',
    'https://www.vivus.ru/documents/redaction/33/0',
    'https://yoomoney.ru/pay/page?id=526623',
    'https://www.vivus.ru/documents/redaction/21/0',
    'https://www.vivus.ru/documents/redaction/71/0',
    'https://www.vivus.ru/documents/redaction/32/0'
  ]
}
